// Copyright (c) 2026 CTO's Club LLC. All rights reserved.

import { z } from 'zod';

const BrowserLocationSchema = z
    .object({
        location: z.object({ origin: z.string().min(1) }).passthrough(),
    })
    .passthrough();

/**
 * Resolves an absolute PILLAR API base URL or a browser-relative, same-origin API path.
 *
 * @param baseUrl - Absolute HTTP URL or root-relative browser path.
 * @returns The absolute URL used to construct PILLAR API requests.
 * @throws Error when the URL form is unsupported or a relative path has no browser origin.
 */
export function resolvePillarApiBaseUrl(baseUrl: string): string {
    if (baseUrl.startsWith('/')) {
        const locationParseResult = BrowserLocationSchema.safeParse(globalThis);
        if (!locationParseResult.success) {
            throw new Error(
                `Invalid baseUrl "${baseUrl}": relative baseUrl requires globalThis.location.origin`
            );
        }
        return `${locationParseResult.data.location.origin}${baseUrl}`;
    }
    if (!baseUrl.startsWith('https://') && !baseUrl.startsWith('http://')) {
        throw new Error(
            `Invalid baseUrl "${baseUrl}": must start with "https://", "http://", or "/"`
        );
    }
    return baseUrl;
}
